<template>
  <div>
    <div class="editEpisodeArea">
      <h2>自分史を入力する</h2>
      <div class="inner">
        <medium-editor
          ref="mediumEditor"
          :content="content"
          :options="options"
          @input="onChange"
          @uploaded="onChange"
          @upload-error="onUploadError"
        />
      </div>
      <!-- /.editEpisodeArea -->
    </div>

    <div class="editApprovalArea">
      <p>
        <label><input v-model="history.allow_comments" type="checkbox"><span>コメントを許可する</span></label>
      </p>
      <!-- /.editApprovalArea -->
    </div>

    <div class="buttonArea">
      <div class="inner">
        <p class="private">
          <button
            type="submit"
            :disabled="formInvalid"
            @click="saveHistory($event)"
          >
            保存する（非公開）
          </button>
        </p>
        <p class="submit">
          <button
            type="submit"
            :disabled="formInvalid"
            @click="postHistory($event)"
          >
            公開する
          </button>
        </p>
      </div>
      <!-- /.buttonArea -->
    </div>

    <!-- モーダル -->
    <modal name="form-submitted" :width="'0%'">
      <div
        id="modalCompleteSave"
        class="modal"
        style="display: block !important;"
      >
        <div class="modalOverlay" />
        <div class="modalInner">
          <dl>
            <dt>{{ modalTitle }}</dt>
            <dd>{{ modalText }}</dd>
          </dl>
          <div class="buttonArea">
            <p class="back">
              <router-link
                :to="{
                  name: 'user-history',
                  params: { id: getLoggedInUser.id }
                }"
              >
                コンテンツ一覧へ戻る
              </router-link>
            </p>
          </div>
          <p class="close">
            <a class="closeModal" @click="closeModal" />
          </p>
        </div>
      </div>
    </modal>
    <modal name="error">
      <div
        id="modalCompleteSave"
        class="modal"
        style="display: block !important;"
      >
        <div class="modalOverlay" />
        <div class="modalInner">
          <dl>
            <dt>エラー</dt>
            <dd>{{ modalError }}</dd>
          </dl>
          <div class="buttonArea">
            <p class="back">
              <a
                class="closeModal"
                @click="closeModal"
              >コンテンツの編集へ戻る</a>
            </p>
          </div>
          <p class="close">
            <a class="closeModal" @click="closeModal" />
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { authComputed } from '@/store/helpers.js'
import NProgress from 'nprogress'
import 'medium-editor/dist/css/medium-editor.css'
import 'medium-editor/dist/css/themes/default.min.css'
import 'vuejs-medium-editor-colorpicker/src/themes/default.css'
import * as requestOptions from '@/helpers/request-options.js'

export default {
  props: {
    propHistory: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      history: null,
      isUploading: false,
      content: '',
      options: {
        placeholder: {
          text: '書きはじめる',
          hideOnClick: true
        },
        toolbar: {
          buttons: [
            { name: 'h3', tagNames: ['h3'], contentDefault: '<h3>見出し</h3>' },
            { name: 'bold', tagNames: ['b'], contentDefault: '<b>太字</b>' },
            { name: 'italic', tagNames: ['i'], contentDefault: '<i>斜体</i>' },
            { name: 'textcolor', contentDefault: '色' },
            {
              name: 'small',
              tagNames: ['small'],
              contentDefault: '<small>キャプション</small>'
            }
          ]
        },
        uploadUrl: requestOptions.baseUrl().baseURL + '/api/images',
        uploadUrlHeader: { Authorization: requestOptions.authHeader() },
        file_input_name: 'file',
        imgur: true
      },
      modalTitle: '',
      modalText: '',
      modalError: ''
    }
  },
  computed: {
    ...authComputed,
    formInvalid: function () {
      if (this.isUploading) {
        return true
      }
      return false
    }
  },
  created () {
    this.history = this.propHistory
    if (this.history.description === undefined) {
      this.history.description = ''
    }
  },
  mounted () {
    if (this.history.description !== '') {
      this.history.description =
        this.history.description +
        '<p><br></p><p><br></p><p><br></p><p><br></p>'
    }
    this.$refs.mediumEditor.editor.setContent(this.history.description)
  },
  methods: {
    closeModal () {
      this.$modal.hide('form-submitted')
      this.$modal.hide('error')
    },
    onChange (content) {
      this.history.description = this.$refs.mediumEditor.editor.getContent()
    },
    onUploadError (error) {
      this.modalError = error
      this.$modal.show('error')
    },
    saveHistory (event) {
      event.preventDefault()
      this.history.display = false
      this.modalTitle = '保存完了'
      this.modalText = 'コンテンツを保存しました。'
      this.updateHistory()
    },
    postHistory (event) {
      event.preventDefault()
      this.history.display = true
      this.modalTitle = '公開完了'
      this.modalText = 'コンテンツを公開しました。'
      this.updateHistory()
    },
    updateHistory () {
      this.isUploading = true
      NProgress.start()

      this.$store
        .dispatch('history/updateHistory', this.history)
        .then(() => {
          this.isUploading = false
          this.$modal.show('form-submitted')
          NProgress.done()
        })
        .catch(() => {
          this.isUploading = false
          NProgress.done()
          this.$router.push({ name: 'logout' })
        })
    }
  }
}
</script>
<style>
@import "../css/medium-editor.css";
.v--modal {
  background-color: rgba(0, 0, 0, 0);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
}
</style>
